import { ENTITY_LIMITS_TABLE_COPY } from '@sonar-software/sonar-ts-constants';
function getItemColumn() {
    return {
        dataIndex: 'item',
        defaultSortOrder: 'ascend',
        key: 'item',
        sorter: (a, b) => a.item.localeCompare(b.item),
        title: ENTITY_LIMITS_TABLE_COPY.ITEM
    };
}
function getUsageColumn() {
    return {
        dataIndex: 'usage',
        sorter: (a, b) => a.usage - b.usage,
        title: ENTITY_LIMITS_TABLE_COPY.USAGE
    };
}
function getLimitColumn() {
    return {
        dataIndex: 'limit',
        sorter: (a, b) => a.limit - b.limit,
        title: ENTITY_LIMITS_TABLE_COPY.LIMIT
    };
}
function getPercentUsedColumn() {
    return {
        dataIndex: 'percentUsed',
        render: (value) => `${value}%`,
        sorter: (a, b) => a.percentUsed - b.percentUsed,
        title: ENTITY_LIMITS_TABLE_COPY.PERCENT_USED
    };
}
export function getColumns() {
    return [
        getItemColumn(),
        getUsageColumn(),
        getLimitColumn(),
        getPercentUsedColumn()
    ];
}
